var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9584 6.25488C55.5232 6.25488 40.1792 14.1002 29.8752 27.5882H21.3333C15.1611 27.5882 11.6235 32.1952 9.18774 37.0672L5.92694 43.5882H13.6251H21.3333L29.3333 51.5882L37.3333 59.5882V67.2965V74.9946L43.8544 71.7344C48.7264 69.2981 53.3333 65.7605 53.3333 59.5882V51.0464C66.8213 40.7424 74.6667 25.3983 74.6667 13.9632V6.25488H66.9584ZM53.3333 22.2549C56.2789 22.2549 58.6667 24.6426 58.6667 27.5882C58.6667 30.5338 56.2789 32.9216 53.3333 32.9216C50.3877 32.9216 48 30.5338 48 27.5882C48 24.6426 50.3877 22.2549 53.3333 22.2549ZM18.6667 54.2549L16 56.9216C12.1483 60.7733 10.6667 70.2549 10.6667 70.2549C10.6667 70.2549 19.7227 69.1989 24 64.9216L26.6667 62.2549L18.6667 54.2549Z",
    fill: "#E84137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.fca4727eab3e9a484765c8188c60b08e.svg";
export { ForwardRef as ReactComponent };